export default [
  {
    path: 'requests',
    children: [
      {
        name: 'requests',
        path: '',
        component: () => import('./RequestsList.vue'),
        meta: {
          title: 'Enquiries'
        }
      },
      {
        name: 'create-request',
        path: 'create',
        component: () => import('./RequestForm.vue'),
        meta: {
          title: 'New Enquiry'
        },
        props: {
          type: 'New'
        }
      },
      {
        name: 'edit-request',
        path: ':id/edit',
        component: () => import('./RequestForm.vue'),
        meta: {
          title: 'Edit Enquiry'
        },
        props: (route) => ({
          type: 'Edit',
          id: route.params.id
        })
      },
      {
        name: 'view-request',
        path: ':id/view',
        component: () => import('./RequestView.vue'),
        meta: {
          title: 'View Enquiry'
        },
        props: (route) => ({
          id: route.params.id
        })
      }
    ]
  },
]

